<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="拼团活动">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="goods-list" >
            <!-- 无限加载滚动列表 -->
            <div class="flex-wrapper" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                <div class="item" v-for='(item, index) in pintuanList' :key='index'>
                    <div class="goods-list-top">
                        <div class="img">
                            <div class="img-content">
                                <img v-lazy="item.pintuan_image" />
                            </div>
                        </div>
                        <div class="goods-info">
                            <div class="info">
                                <div class="goods_nameBox">
                                    <div class="goods_nameText">
                                        <span>{{item.pintuan_goods_name}}</span>
                                    </div>
                                </div>
                                <div class="p">
                                    已开团{{item.pintuan_count}}组
                                </div>
                                <div class="goods_price_wrap">
                                    <div class="now_price">
                                        <span class="small_price">
                                            <span>$</span>
                                        </span>
                                        <span class="big_price">
                                            <span>{{item.pintuan_zhe_price}}</span>
                                        </span>
                                    </div>
                                    <div class="old_price">
                                        ${{item.pintuan_goods_price}}
                                    </div>
                                </div>
                                <div class="navigator" @click="goDetail(item)">
                                    <div class="group_num_wrap">
                                        <div class="iconImg">
                                            <span class="iconfont icon-text">&#xe6f0;</span>
                                        </div>
                                        <div class="text-content">
                                            <span>{{item.pintuan_limit_number}}人团</span>
                                        </div>
                                    </div>
                                    <div class="go_to_group">
                                        去拼团
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loading-wrapper" v-if="pintuanList.length > 0">
                    <p class="common-no-more" v-if='!isMore'>没有更多了</p>
                    <mt-spinner type="triple-bounce" color='#e93b3d' v-if='isMore'></mt-spinner>
                </div>
                <empty-record v-if='pintuanList.length <= 0 && !isMore'></empty-record>
            </div>
        </div>

    </div>
</template>

<script>
import EmptyRecord from '../../EmptyRecord'
import CountDown from '../../CountDown'
import { Toast, Indicator } from 'mint-ui'
import { getPintuanList } from '../../../api/homesearch'
export default {
  name: 'PintuanList',
  components: {
    EmptyRecord,
    CountDown
  },
  data () {
    return {
      pintuanList: [],
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true // 是否有更多
    }
  },
  methods: {
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getPintuanList(true)
      }
    },
    getPintuanList () {
      Indicator.open()
      getPintuanList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        if (this.pintuanList) {
          this.pintuanList = this.pintuanList.concat(res.result.pintuan_list)
        } else {
          this.pintuanList = res.result.pintuan_list
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
    goDetail (item) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': item.pintuan_goods_id } })
    }
  }
}
</script>

<style scoped lang='scss'>

    .goods-list {padding: 0 10px;}
    .goods-list *{flex-direction: column;}
    .goods-list .item {display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-webkit-flex-direction: column;flex-direction: column;border-radius: 7px;box-sizing: border-box;background-color: #fff;font-size:$fontSize;color: #999;margin-top: 10px;padding: 10px 10px 20px 10px}
    .goods-list-top .img {position: relative;width: 135px;height: 135px;margin-right: 10px;background-color: #f8f8f8;border-radius: 7px}
    .img .img-content {width: 135px;height: 135px;border-radius: 7px}
    .img .img-content >img{display: block;position: absolute;top: 0;left: 0;width: 100%;height: 100%;}
    .goods-list .item {display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-webkit-flex-direction: column;flex-direction: column}
    .goods-list-top {display: -webkit-box;display: -webkit-flex;display: flex;flex-direction: row;}
    .goods-info {display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-orient: vertical;-webkit-box-direction: normal;-webkit-flex-direction: column;flex-direction: column;position: relative}
    .goods-info .info .goods_nameBox {margin-bottom: 2px}
    .goods-info .goods_price_wrap {display: flex;margin-top: 15px;flex-direction: row;align-items: baseline;}
    .goods_price_wrap .now_price {font-size:$fontSize;font-weight: 600;color: #fc1c1c;font-weight: 700}
    .now_price .big_price {font-size:$h1}
    .goods-info .info .old_price {color: #9a9a9a;font-size:$h6;margin-left: 5px;text-decoration: line-through;padding-bottom: 2px}
    .goods-info .info .p {font-size:$fontSize;color: #666;display: -webkit-box;display: -webkit-flex;display: flex;}
    .goods-info .p .line {display: block;width: 1px;height: 10px;margin: 0 7px;background-color: #999}
    .goods-info .navigator {display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-align: center;-webkit-align-items: center;align-items: center;-webkit-box-pack: center;-webkit-justify-content: center;justify-content: center;width: 140px;height: 25px;color: #fff;font-size:$subFontSize;border-radius: 19px;position: absolute;bottom: 0;left: 0;flex-direction: row;}
    .group_num_wrap {display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-pack: center;-webkit-justify-content: center;justify-content: center;-webkit-box-align: center;-webkit-align-items: center;align-items: center;width: 75px;height: 23px;color: #fc1c1c;font-size:$fontSize;border-radius: 12px 0 0 12px;border: 1px solid #fc1c1c;padding-right: 10px;flex-direction: row;}
    .goods-info .iconImg {width: 15px;height: 13px;margin-right: 5px;position: relative;}
    .goods-info .iconImg .icon-text{display: block;position: absolute;top: 0;left: 0;width: 100%;height: 100%;font-size:$h2;line-height: 13px;}
    .go_to_group {display: -webkit-box;display: -webkit-flex;display: flex;-webkit-box-align: center;-webkit-align-items: center;align-items: center;-webkit-box-pack: center;-webkit-justify-content: center;justify-content: center;width: 74px;height: 25px;font-size: $subFontSize;color: #fff;background-color: #fc1c1c;border-radius: 0 12px 12px 12px;margin-left: -15px}
    .goods_nameBox {margin-top: 10px}
    .goods_nameText {color: #2e2e2e;font-size:$subFontSize;font-weight: 600;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical}
    .group_bottom_text {white-space: nowrap;text-overflow: ellipsis;overflow: hidden}
</style>
